import { TablePagination } from "@mui/material";

export default function TablePaginationComponent({
  count,
  page,
  onPageChange,
  rowsPerPage,
  onRowsPerPageChange
}: any) {
  return (
    <TablePagination
      // MUI builds this on TableCell, so it renders a <td> unless told
      // otherwise. Table.tsx places it in a Box after the </Table>, where a <td>
      // is invalid HTML and React warns about the nesting.
      component="div"
      count={count}
      page={page - 1}
      onPageChange={(_, selected) => onPageChange(selected + 1)}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={e => onRowsPerPageChange(e.target.value)}
      sx={{
        borderRadius: "40px",
        boxShadow: "0px 0px 4px rgba(30, 39, 79, 0.12)",
        bgcolor: "#FCFCFF",
        ".MuiTablePagination-toolbar": {
          padding: "0 16px"
        }
      }}
    />
  );
}
